export enum StaffErrorType {
    Unknown = 'Unknown'
}

export class StaffError extends Error {
    name = 'StaffError';
    type: StaffErrorType;

    constructor(type: StaffErrorType = StaffErrorType.Unknown, message?: string) {
        super(message ?? StaffErrorMessages[type]);

        this.type = type;
    }
}

export const StaffErrorMessages: Record<StaffErrorType, string> = {
    [StaffErrorType.Unknown]: 'Oops, something went wrong.'
};
